//This component was created just for the sections that are completely hardcoded in @ecomm/scout and no content-type was created for them.
import { useLocale } from '@ecomm/data-hooks/useLocale'
import { useHeaderRedesignQuery } from '@ecomm/header'
import {
  DeadEnd,
  ExpertSection,
  MonitoringAccolades,
  UserStories,
  useExpertSectionData,
  useMonitoringPageAccoladesData,
  useMonitoringPageDeadEndData,
  useMonitoringPageUserStoriesData
} from '@ecomm/scout'
import { AntiTheftGuaranteeBanner } from '@ecomm/shop-components/AntiTheftGuaranteeBanner'

//Renders each component based on the label of a placeholder.
export function MonitoringHardcodedComponent({
  label
}: {
  readonly label: string
}) {
  const locale = useLocale()
  const isUS = locale === 'en-US'
  const { quoteWizard } = useHeaderRedesignQuery()
  const monitoringPageAccoladesData = useMonitoringPageAccoladesData()
  const monitoringPageDeadEndData = useMonitoringPageDeadEndData()
  const expertSectionData = useExpertSectionData()
  const monitoringPageUserStoriesData = useMonitoringPageUserStoriesData()

  const components: Record<string, JSX.Element> = {
    ...(isUS && {
      'Anti-Theft Guarantee Banner': <AntiTheftGuaranteeBanner />
    }),
    'Monitoring Page: Accolades': (
      <div
        className="prose-h2:mb-6 prose-h2:md:mb-8 pb-8 md:pb-0"
        data-component="MonitoringAccolades"
        data-testid="MonitoringAccolades"
      >
        <MonitoringAccolades data={monitoringPageAccoladesData} />
      </div>
    ),
    'Monitoring Page: Dead End Nav Component': (
      <DeadEnd
        data={{
          ...monitoringPageDeadEndData,
          quoteWizard: quoteWizard
        }}
      />
    ),
    'Monitoring Page: Help Widget': <ExpertSection data={expertSectionData} />,
    'Monitoring Page: User Story Cards': (
      <UserStories data={monitoringPageUserStoriesData} />
    )
  }

  return label in components ? components[label] : null
}
